<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(760px, calc(100vw - 32px))">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button
              v-if="isAuth('sale:customer:update')"
              type="primary"
              size="small"
              @click="editFromView"
            >修改</el-button>
            <el-button
              v-if="isAuth('sale:customer:delete')"
              type="primary"
              size="small"
              :disabled="actionLoading"
              @click="deleteHandle"
            >删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="100px">
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12">
          <el-form-item label="客户编码" prop="customerCode">
            <el-input v-model="dataForm.customerCode" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="dataForm.customerName" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12">
          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="dataForm.contactPerson" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="dataForm.phone" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12">
          <el-form-item label="地址" prop="address">
            <el-input v-model="dataForm.address" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="税号" prop="taxNumber">
            <el-input v-model="dataForm.taxNumber" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12">
          <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="dataForm.bankName" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="银行账号" prop="bankNumber">
            <el-input v-model="dataForm.bankNumber" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12">
          <el-form-item label="信用额度">
            <el-input-number v-model="dataForm.creditLimit" :min="0" :precision="2" :disabled="dialogReadonly" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="账期(天)">
            <el-input-number v-model="dataForm.paymentTermDays" :min="0" :precision="0" :disabled="dialogReadonly" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="3" :disabled="dialogReadonly" />
      </el-form-item>
      <el-form-item label="启用" prop="isenabled">
        <el-switch v-model="enabledSwitch" :disabled="dialogReadonly" active-color="#13ce66" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!dialogReadonly" type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCustomer, saveOrUpdateCustomer, deleteCustomer } from '../../api/sale/customer'

function emptyForm() {
  return {
    customerId: '',
    customerCode: '',
    customerName: '',
    contactPerson: '',
    phone: '',
    address: '',
    taxNumber: '',
    bankName: '',
    bankNumber: '',
    creditLimit: null,
    paymentTermDays: null,
    isenabled: '0',
    remark: ''
  }
}

export default {
  name: 'SaleCustomerDialog',
  props: {
    isAuth: { type: Function, required: true }
  },
  data() {
    return {
      visible: false,
      dialogReadonly: false,
      viewMode: false,
      actionLoading: false,
      dialogTitle: '新增客户',
      enabledSwitch: true,
      dataForm: emptyForm(),
      dataRule: {
        customerCode: [{ required: true, message: '客户编码不能为空', trigger: 'blur' }],
        customerName: [{ required: true, message: '客户名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    showViewToolbar() {
      return this.viewMode && !!this.dataForm.customerId
    }
  },
  methods: {
    editFromView() {
      this.viewMode = false
      this.dialogReadonly = false
      this.dialogTitle = '修改客户'
    },
    deleteHandle() {
      this.$confirm('确定删除该客户?', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        deleteCustomer(this.dataForm.customerId).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {
          // 拦截器已弹出服务端原因，例如「该客户已存在销售订单，无法删除」
        }).finally(() => {
          this.actionLoading = false
        })
      }).catch(() => {})
    },
    init(id, readonly) {
      this.viewMode = !!readonly
      this.dialogReadonly = !!readonly
      this.actionLoading = false
      this.dialogTitle = readonly ? '查看客户' : (id ? '修改客户' : '新增客户')
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields()
        }
        this.dataForm = emptyForm()
        this.dataForm.customerId = id || ''
        this.enabledSwitch = true
        if (id) {
          this.fetchDetail(id)
        }
      })
    },
    fetchDetail(id) {
      getCustomer(id).then(res => {
        const body = res.data
        if (body) {
          Object.assign(this.dataForm, body)
          this.dataForm.creditLimit = body.creditLimit != null ? Number(body.creditLimit) : null
          this.dataForm.paymentTermDays = body.paymentTermDays != null ? Number(body.paymentTermDays) : null
          this.enabledSwitch = body.isenabled !== '1'
          this.$nextTick(() => {
            if (this.$refs.dataForm) {
              this.$refs.dataForm.clearValidate()
            }
          })
        }
      }).catch(() => {
        this.$message.error('加载客户信息失败')
      })
    },
    dataFormSubmit() {
      this.dataForm.isenabled = this.enabledSwitch ? '0' : '1'
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const payload = { ...this.dataForm }
        if (!payload.customerId) {
          delete payload.customerId
        }
        saveOrUpdateCustomer(payload).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 28px;
}
.doc-dialog-title {
  font-size: 16px;
  font-weight: 600;
}
</style>
